<template>
  <div class="intro">
    <div class="intro__innerwrap">
      <div class="intro__row">
        <div class="intro__col">
          <h1 class="intro__title" v-html="page.title"></h1>
        </div>
        <div class="intro__col">
          <div class="intro__image" :style="{ backgroundImage: `url('${image}')`}"></div>
          <div class="intro__content" v-html="page.content"></div>
        </div>
      </div>
    </div>
    <bottom-nav
      :prev="{ to: '/welcome', label: 'Welcome to Kyocera' }"
      :next="{ to: '/benefits', label: 'Benefits' }"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BottomNav from '@/components/BottomNav';

export default {
  name: 'Intro',
  components: { BottomNav },
  computed: {
    ...mapState(['pages']),
    page() {
      return this.pages.intro;
    },
    image() {
      return `static/${this.page.image}`;
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.intro {
  @include section(true);

  &__row {
    display: flex;
  }

  &__image {
    display: block;
    width: calc(100%x + #{$global_margin});
    margin: (-$section-padding-top - 30px) (-$global_margin) 0 0;
    background-size: cover;
    background-position: center;
    position: relative;
    min-height: 400px;

    &::after {
      content: '';
      display: block;
      background-image: url('../assets/intro_arrow.svg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      padding-top: 72.5% * 0.75;
      width: 75%;
      position: absolute;
      bottom: 30px;
      left: -28%;
    }
  }

  &__title {
    @include font-heading;
    width: calc(6/12 * 100% - #{$global_margin} - 10px);
    position: fixed;
  }

  &__col {
    width: calc(6/12 * 100% - 10px);

    &:not(:last-child) {
      margin-right: 10px;
    }

    &:not(:first-child) {
      margin-left: 10px;
    }
  }

  &__content {
    @include font-content;
    // width: calc(50% - 10px);
    // margin-left: calc(50% + 10px);
    margin-top: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Intro.vue